/** COCO 语音 API */
export const DEFAULT_COCO_ORIGIN = 'https://gfdrmecoxjgz.sealosgzg.site';

/** HTTP 备用（整段录音），浏览器默认走同源代理 */
export const COCO_API_BASE = (
  import.meta.env.VITE_COCO_API_BASE || '/api/coco'
).replace(/\/$/, '');

export const COCO_API_KEY = import.meta.env.VITE_COCO_API_KEY || '';
export const COCO_SESSION_KEY = 'coco_session';

/**
 * 语音助手模式：
 * - false（默认）：WebSocket 推流 + 服务端识别，不依赖 Chrome 联网 STT，大屏更稳定
 * - true：embed.js 浏览器 SpeechRecognition（国内网络下常无法识别）
 */
export const COCO_USE_WEB_SPEECH_WAKE = import.meta.env.VITE_COCO_USE_WEB_SPEECH_WAKE === 'true';

/** WebSocket 监听模式（fast_wake，旧方案，embed 模式下不使用） */
export const COCO_WS_REQUIRE_WAKE = true;
export const COCO_WS_WITH_TTS = true;
export const COCO_WS_AUTO_CONTINUE = true;
export const COCO_WS_FAST_WAKE = true;
export const COCO_WS_SKIP_WAKE_TTS = true;
export const COCO_WS_SILENCE_DURATION = 0.7;

export const WAKE_PHRASE = '小可同学';
export const WAKE_ACK_TEXT = '我在呢，请说。';

/**
 * 语音助手模式：local = 浏览器本地唤醒（默认）；coco = COCO 云端（保留备用）
 */
export const VOICE_ASSISTANT_MODE = import.meta.env.VITE_VOICE_ASSISTANT_MODE || 'local';

/** PCM 推流：16kHz mono int16，约每 100ms 一帧 */
export const COCO_PCM_SAMPLE_RATE = 16000;
export const COCO_PCM_CHUNK_MS = 100;
